module.exports = __webpack_public_path__ + "img/icb-co-Adv-m@3x.f8e36b6d.png";